const CheckMarginMapper = (response) => {
    if (response) {
        return {
            orderMargin: response.ordMargin,
            availableCash: response.availCash,
            marginUsed: response.marginUsed,
            insufficientFund: response.insfFund,
            emsg: response.emsg,
            status: response.stat,
        };
    }
    return {};
};
export default CheckMarginMapper;
